<template>
    <v-menu bottom left offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on"><v-icon>mdi-menu</v-icon></v-btn>
        </template>
        <v-list flat>
            <v-subheader>{{ username }}</v-subheader>
            <v-divider></v-divider>
            <v-list-item link to="/">Home</v-list-item>
            <v-divider></v-divider>
            <v-list-item link to="/atendimento">Novo Chamado</v-list-item>
            <v-divider></v-divider>
            <v-list-item link to="/chamados/abertos">
                <v-badge
                    inline
                    :content="numAbertosNaoVisualizados + ' novos'"
                    :value="numAbertosNaoVisualizados"
                >
                    Chamados Abertos
                </v-badge>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item link to="/chamados/fechados"
                ><v-badge
                    inline
                    :content="numFechadosNaoVisualizados + ' novos'"
                    :value="numFechadosNaoVisualizados"
                >
                    Chamados Fechados
                </v-badge></v-list-item
            >
            <v-divider></v-divider>
            <v-list-item link to="/chamados/buscar">
                Buscar Chamados
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item link to="/admin" v-if="isAdmin || isSuperAdmin"
                >Administração</v-list-item
            >
            <v-divider></v-divider>
            <v-list-item link @click="logout">Sair</v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    name: "MenuMobile",
    computed: {
        ...mapGetters("autenticacao", ["username", "isSuperAdmin", "isAdmin"]),
        ...mapGetters("visualizacoes", [
            "numAbertosNaoVisualizados",
            "numFechadosNaoVisualizados",
        ]),
    },
    methods: {
        ...mapActions("autenticacao", {
            logout: "LOGOUT",
        }),
    },
};
</script>
